const DEV_MODE = import.meta.env.VITE_DEV_MODE || 'localhost';

let baseUrl: string;
let baseUrla: string;

switch (DEV_MODE) {
  case 'localhost':
    // Développement local
    baseUrl = 'http://127.0.0.1:3000';
    baseUrla = 'http://127.0.0.1:5000';
    break;

  case 'local-api-remote':
    // Frontend en local, backend sur serveur distant non sécurisé (HTTP)
    baseUrl = 'http://127.0.0.1:3000';
    baseUrla = 'http://pro.alia-immo.com'; // HTTP pour tests si HTTPS non encore dispo
    break;

  case 'remote':
    // Production : tout en HTTPS avec SSL Let's Encrypt
    baseUrl = 'https://pro.alia-immo.com';
    baseUrla = 'https://pro.alia-immo.com';
    break;

  default:
    baseUrl = 'http://127.0.0.1:3000';
    baseUrla = 'http://127.0.0.1:5000';
}

// URL finale de l’API
export const baseUrlApi: string = `${baseUrla}/api/v1`;
export { baseUrl, baseUrla };

// Logs en mode DEV
if (import.meta.env.DEV) {
  console.log('🔧 Configuration URLs');
  console.log('📍 Mode:', DEV_MODE);
  console.log('📍 Frontend URL:', baseUrl);
  console.log('📍 Backend URL:', baseUrla);
  console.log('📍 API URL:', baseUrlApi);
}